import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowForward = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" })
});
export default SvgArrowForward;
